import React, { Component } from 'react';
import { reduxForm, Field, FieldArray } from 'redux-form';
import { Form, Alert, Button, Row, Col } from 'antd';
import AntIcon from '../../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import {
  formItemLayout,
  renderInput,
  renderTextarea,
  renderSelect,
} from '../../shared/utils/form_components';
import { required } from '../../shared/utils/form_validations';
import ColorwayFields from './ColorwayFields';

class CatalogForm extends Component {

  render() {
    const { handleSubmit, deleteError, error, submitting, deleteButton, brands } = this.props;
    const err = deleteError || error;

    const BrandOptions = [{ label: 'Unknown', value: null }]
      .concat(brands.map(({ _id, title }) => ({ label: title, value: _id })));

    const filterOptions = (value, option) =>
      option.props.children.toLowerCase().includes(value.toLowerCase());

    return (
      <Form layout="horizontal" onSubmit={handleSubmit}>

        <Row>
          <Col lg={18} xs={24}>

            <Form.Item>
              <Row gutter={[8, 8]} type="flex" justify="end" className="page-form-actions">
                <Col>
                  <Button>
                    <Link to="/catalog">Cancel</Link>
                  </Button>
                </Col>
                <Col>{deleteButton}</Col>
                <Col>
                  <Button
                    disabled={submitting} loading={submitting}
                    type="primary" htmlType="submit"
                  >
                    <AntIcon type="save" />Save
                  </Button>
                </Col>
              </Row>
            </Form.Item>

            {err && <Form.Item><Alert message={err} type="error" /></Form.Item>}

            <Form.Item
              {...formItemLayout}
              label="Name"
              required
            >
              <Row gutter={10}>
                <Col span={14}>
                  <Field
                    inputOnly
                    name="name"
                    placeholder="Name"
                    component={renderInput}
                    validate={required}
                  />
                </Col>
                <Col span={10}>
                  <Field
                    name="date"
                    placeholder="2017"
                    label="Date"
                    required
                    component={renderInput}
                    validate={required}
                  />
                </Col>


                <Form.Item
                  {...formItemLayout}
                  required
                  label="Brand"
                >
                  <Row gutter={8}>
                    <Col span={10}>
                      <Field
                        inputOnly
                        showSearch
                        filterOption={filterOptions}
                        name="brand._id"
                        placeholder="Unknown"
                        options={BrandOptions}
                        component={renderSelect}
                      />
                    </Col>
                  </Row>
                </Form.Item>

              </Row>
            </Form.Item>

            <Field
              name="description"
              label="Description"
              autosize={{ minRows: 3 }}
              required
              component={renderTextarea}
              validate={required}
            />

          </Col>
        </Row>

        <Row>
          <Col sm={{ offset: 3 }}>
            <h3>Colorways:</h3>
          </Col>
        </Row>
        <FieldArray name="colorways" component={ColorwayFields} />

      </Form>
    );
  }
}

const validate = ({ name, date, description, colorways })  => {
  const errors = {};
  if (name && date && description && (!colorways || !colorways.length)) {
    errors._error = "Please add at least one colorway.";
  }
  return errors;
}

export default reduxForm({
  validate,
  form: 'CatalogForm',
})(CatalogForm);
